import { render, staticRenderFns } from "./index.vue?vue&type=template&id=621523f4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621523f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621523f4')) {
      api.createRecord('621523f4', component.options)
    } else {
      api.reload('621523f4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=621523f4&scoped=true", function () {
      api.rerender('621523f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/priceMonitoring/index.vue"
export default component.exports